import { FailedPaymentDetails } from "./types";

/**
 * Generates the title for the payment failed banner based on the failure details.
 * Priority: returnCode + returnReason > failureReason > "Payment failed"
 *
 * @param failedPaymentDetails - The details of the failed payment
 * @returns The banner title string
 */
export const getPaymentFailedBannerTitle = (
  failedPaymentDetails: FailedPaymentDetails,
): string => {
  const { returnCode, returnReason, failureReason } = failedPaymentDetails;

  if (returnCode && returnReason) {
    return `Payment failed: ${returnReason} (ACH return code: ${returnCode})`;
  }

  if (returnReason) {
    return `Payment failed: ${returnReason}`;
  }

  if (returnCode) {
    return `Payment failed: ACH return code ${returnCode}`;
  }

  if (failureReason) {
    return `Payment failed: ${failureReason}`;
  }

  // Default fallback
  return "Payment failed";
};
